import { Component } from "react";

export default class SafeBlock extends Component {
    constructor(props) { super(props); this.state = { error: null }; }
    static getDerivedStateFromError(error) { return { error }; }
    componentDidCatch(error) { console.error("SafeBlock:", error); }
    render() {
        if (this.state.error) {
            return <div data-testid="safe-block-error" className="rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-xs text-amber-800">{this.props.label || "Ce bloc"} n&apos;a pas pu s&apos;afficher ({String(this.state.error?.message || this.state.error).slice(0, 120)}). Le reste de la page reste utilisable.</div>;
        }
        return this.props.children;
    }
}
